var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-10 flex justify-between items-center"},[_c('div',{staticClass:"relative w-96"},[_c('text-input',{staticClass:"h-10",attrs:{"placeholder":"Find a course"}}),_c('i',{staticClass:"fas fa-search absolute right-0 top-0 mr-3 mt-3"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }